import React, { useCallback, useState } from 'react';
import { Message } from '@kvdbil/components';
import { VerifyBankID } from '~/App/shared/components/Auth/VerifyBankID';
import { useTranslation } from '~/Locale';
import StatusPageLoading from '~/App/shared/components/StatusPageLoading';
import OrganisationMemberDetailsForm, {
  FormData
} from './OrganisationMemberDetailsForm';
import { useMemberDataUpdate } from '../../hooks/useMemberDataUpdate';

interface Props {
  isPending: boolean;
  setIsPending: (isPending: boolean) => void;
}

const BiddingOrgPersonBankIdVerification = ({
  isPending,
  setIsPending
}: Props) => {
  const { t } = useTranslation();
  const [organisationDetailsFormData, setOrganisationDetailsFormData] =
    useState<FormData | null>(null);
  const {
    saveAccountDetailsCallback,
    isSavingAccountDetails,
    isSavingAccountDetailsError
  } = useMemberDataUpdate();

  const onSuccessBankIdVerificationCallback = useCallback(() => {
    setTimeout(() => {
      organisationDetailsFormData &&
        void saveAccountDetailsCallback(organisationDetailsFormData);
      setIsPending(false);
    }, 2000);
  }, [setIsPending, saveAccountDetailsCallback, organisationDetailsFormData]);

  if (isPending) {
    return (
      <VerifyBankID
        onClose={() => setIsPending(false)}
        onSuccess={onSuccessBankIdVerificationCallback}
      />
    );
  }

  if (isSavingAccountDetails) {
    return (
      <>
        {isSavingAccountDetails && <StatusPageLoading />}
        {isSavingAccountDetailsError && (
          <Message type="error" fullWidth>
            {t('Something went wrong, please try again later.')}
          </Message>
        )}
      </>
    );
  }

  return (
    <OrganisationMemberDetailsForm
      organisationDetailsFormData={organisationDetailsFormData}
      setOrganisationDetailsFormData={setOrganisationDetailsFormData}
      handleSubmitButtonClick={() => setIsPending(true)}
      accountVerificationStatus="VERIFY_ORG_PERSON_BANKID"
    />
  );
};

export default BiddingOrgPersonBankIdVerification;
